var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@willphan1712000/frontend';
import useLanguageContext from '../../languages/context';
import languages from '../../languages';
const Language = (_a) => {
    var otherProps = __rest(_a, []);
    const [language, setLanguage] = useLanguageContext();
    return (_jsx(Button, Object.assign({}, otherProps, { onClick: () => {
            if (language.type === 'en') {
                localStorage.setItem('language', 'vn');
                setLanguage(languages.vn);
            }
            else {
                localStorage.setItem('language', 'en');
                setLanguage(languages.en);
            }
        }, buttonType: "solid", className: "text-[12px]" })));
};
export default Language;
